import React from 'react'
import PropTypes from 'prop-types'

const button = ({ name, href, className}) => {
  return (
    <a className={className} href={href}>{name}</a>
  )
}

button.defaultProps = {
    color: 'green',
}

button.propTypes = {
    text: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
}

export default button